export class DeviceVersion
{
    OSVersion: string;
    AppVersion: string;
    constructor(
        osVersion: string,
        appVersion: string
    ) {
        this.OSVersion = osVersion;
        this.AppVersion = appVersion;
    }
}